'use client';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { motion } from 'framer-motion';
import MuxPlayer from '@mux/mux-player-react';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

type Media = {
  url: string;
  alternativeText?: string;
};

type Child = {
  text: string;
};

type Paragraph = {
  children: Child[];
};

type Button = {
  button_text: string;
  button_url: string;
  open_link_in_new_tab?: boolean;
};

type NerdiaBoxItem = {
  title: string;
  designation: string;
  description: Paragraph[];
  button: Button[];
  mux_video?: any;
  enable_mux_video: boolean;
  media?: {
    desktop_media?: Media[];
  };
};
type SectionsAanerdiaBoxProps = {
  data: {
    nerdia_box: NerdiaBoxItem[];
    padding: {
      mobile_top_padding: any;
      mobile_bottom_padding: any;
      desktop_top_padding: any;
      desktop_bottom_padding: any;
    };
    __typename: string;
  };
};
type BlocksRendererProps = React.ComponentProps<typeof BlocksRenderer>;

const ComponentSectionsAanerdiaBox = ({ data }: SectionsAanerdiaBoxProps) => {
  const { nerdia_box } = data;
  const [top, setTop] = useState('');
  const [bottom, setBottom] = useState('');

  useEffect(() => {
    const updatePadding = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setTop(data.padding?.mobile_top_padding ?? '');
        setBottom(data.padding?.mobile_bottom_padding ?? '');
      } else {
        setTop(data.padding?.desktop_top_padding ?? '');
        setBottom(data.padding?.desktop_bottom_padding ?? '');
      }
    };

    updatePadding(); // Run on mount

    window.addEventListener('resize', updatePadding); // Listen on resize
    return () => window.removeEventListener('resize', updatePadding); // Clean up
  }, [data]);

  console.log('data', data);
  return (
    <>
      <section
        className="grid grid-cols-1 sm:grid-cols-2 gap-10 xl:px-16 pb-24 twocolumn"
        style={{
          paddingTop: `${top}rem`,
          paddingBottom: `${bottom}rem`,
        }}
        id={data?.__typename}
      >
        {nerdia_box.map((box, idx) => {
          const muxPlaybackId = box?.mux_video?.playback_id;
          const enableMuxVideo = box.enable_mux_video;
          return (
            <motion.div
              key={idx}
              className="img-box group w-full md:max-w-[81%] flex flex-col-reverse md:flex-col gap-3"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.2 }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <div className="flex justify-between">
                <h3 className="text-[#B6C380] font-light text-base leading-none">{box.title}</h3>
                <p className="text-base text-cream font-light leading-none">{box.designation}</p>
              </div>

              <div className="relative w-full overflow-hidden">
                {enableMuxVideo && muxPlaybackId ? (
                  <MuxPlayer
                    playbackId={muxPlaybackId}
                    autoPlay
                    muted
                    loop
                    playsInline
                    streamType="on-demand"
                    style={{ width: '100%' }}
                  />
                ) : (
                  <>
                    {box.media?.desktop_media?.[0]?.url && (
                      <Image
                        src={box.media.desktop_media[0].url}
                        alt={box.media.desktop_media[0].alternativeText || box.title}
                        fill
                        className="object-cover w-full !relative"
                      />
                    )}
                  </>
                )}

                <div className="absolute inset-0 bg-[#B6C380] bg-opacity-100 text-[#2B332A] font-light leading-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 px-4 pt-6 pb-4 flex flex-col justify-between">
                  {/* Description */}
                  <div className="space-y-3 text-sm blocksRenderer">
                    {/* {box.description.map((para: Paragraph, pIdx: number) => (
                      <p key={pIdx}>
                        {para.children.map((child, cIdx) => (
                          <span className="indent-10 block" key={cIdx}>
                            {child.text}
                          </span>
                        ))}
                      </p>
                    ))} */}
                    <div className="indent-16">
                      <BlocksRenderer content={box.description as BlocksRendererProps['content']} />
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="flex gap-4 flex-wrap justify-between leading-none">
                    {box.button.map((btn, bIdx) => (
                      <a
                        key={bIdx}
                        href={btn.button_url}
                        target={btn.open_link_in_new_tab ? '_blank' : '_self'}
                        rel="noopener noreferrer"
                        className="text-[#2B332A] transition"
                      >
                        {btn.button_text}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </section>
    </>
  );
};

export default ComponentSectionsAanerdiaBox;
